import { render, staticRenderFns } from "./ObjectRelations.vue?vue&type=template&id=6b8af980&scoped=true&"
import script from "./ObjectRelations.vue?vue&type=script&lang=ts&"
export * from "./ObjectRelations.vue?vue&type=script&lang=ts&"
import style0 from "./ObjectRelations.vue?vue&type=style&index=0&id=6b8af980&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8af980",
  null
  
)

export default component.exports